import { render, staticRenderFns } from "./LoginWithCognito.vue?vue&type=template&id=078d25be"
import script from "./LoginWithCognito.vue?vue&type=script&lang=js"
export * from "./LoginWithCognito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports